namespace Matrix.Data {
    export interface PartyRoleRow {
        RoleCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        PartyList?: string[];
    }

    export namespace PartyRoleRow {
        export const idProperty = 'RoleCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Data.PartyRole';
        export const lookupKey = 'Data.PartyRole';

        export function getLookup(): Q.Lookup<PartyRoleRow> {
            return Q.getLookup<PartyRoleRow>('Data.PartyRole');
        }
        export const deletePermission = 'DataAdmin:PartyRole';
        export const insertPermission = 'DataAdmin:PartyRole';
        export const readPermission = 'Read:PartyRole';
        export const updatePermission = 'DataAdmin:PartyRole';

        export declare const enum Fields {
            RoleCode = "RoleCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            PartyList = "PartyList"
        }
    }
}
